export interface ISerologyData {
    // pcrTestHours: number,
    // serologyTurnaround: number,
    // isSerologyParticipant: number,
    serologyMaxDaysBeforeSurgery: number,
    serologyShipToId: number,
    requiresQfg: number,
    serologyTests: number[]
}